import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import { HttpEvent, HttpRequest, HttpHandler, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { ActiveAjaxLoadersService, XHR_REQUEST_STATES } from './active-ajax-loaders.service';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class AjaxLoaderInterceptor implements HttpInterceptor {

    private loaderProp = 'ajax_loader';
    constructor(private activeAjaxLoadersService: ActiveAjaxLoadersService) { }
    

    intercept(request: HttpRequest<any>, httpHandler: HttpHandler): Observable<HttpEvent<any>> {
        const loaderName = request.headers.get(this.loaderProp);
        const newReq = request.clone({
          headers: request.headers.delete(this.loaderProp)
        });
        this.updateLoaderState(loaderName, XHR_REQUEST_STATES.PROGRESS);
        return httpHandler.handle(newReq).pipe(
          tap((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              this.updateLoaderState(loaderName, XHR_REQUEST_STATES.SUCCESS, event);
            }
          }),
          catchError((responseError: any) => {
            if (responseError instanceof HttpErrorResponse) {
              const responseErrorBody = responseError.error;
              let errorMessage = 'Unknown Error in API call. ' + loaderName;
    
              if (responseErrorBody && typeof responseErrorBody.error_msg === 'string') {
                errorMessage = responseErrorBody.error || responseErrorBody.message || JSON.stringify(responseErrorBody);
              } else  {
                let errorList = responseErrorBody.error_msg;
                let errorString = '<ol>';
                if(Array.isArray(errorList)){
                  errorList.forEach((error: any) => {
                    errorString += '<li>' + error + '</li>';
                  });
                }
                errorString += '</ol>';
                errorMessage =
                  responseErrorBody.error || responseErrorBody.message || JSON.stringify({ error_msg: errorString });
              }
    
              this.updateLoaderState(loaderName, XHR_REQUEST_STATES.ERROR, { error: errorMessage });
            }
            return throwError(responseError);
          })
        );
      }

    private updateLoaderState(loaderName, loaderState, data?) {
        if (loaderName) {
            this.activeAjaxLoadersService.update(loaderName, loaderState, data);
        }
    }
}
